import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/react';
import React from 'react';

interface UploadErrorAlertProps {
    errs: string[];
}

const UploadErrorAlert = (
    { errs }: UploadErrorAlertProps
) => {
    if (errs && errs.filter((e) => !!e).length > 0) {
        return (
            <Alert
                status="error"
                borderRadius="10px"
                mt="12px"
                alignItems="flex-start"
            >
                <AlertIcon />
                <AlertDescription data-testid="alert-api-error">
                    <strong>Reason: </strong>
                    <br />
                    <span
                        dangerouslySetInnerHTML={{
                            __html: errs.join("<br />"),
                        }}
                    />
                </AlertDescription>
            </Alert>
        );
    }

    return <></>;
};

export default UploadErrorAlert;